// src/lib/axios.ts
import axios from "axios";

const base =
  (import.meta.env.VITE_API_BASE_URL || "/api").replace(/\/$/, ""); // no trailing slash

const api = axios.create({
  baseURL: base,          // <-- same-origin /api
  withCredentials: true,  // if you use cookies/sessions
  // headers: { ... }      // optional
});

export default api;

